// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1K0oU","tab":"ProcedureTabs_tab__2o841"};